export default __webpack_public_path__ + "static/media/english-to-arabic-screenshot-04.537e905c.png";